import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterEntitiesPipe } from './dropDownFilter.pipe';
import { FilterSubEntitiesPipe } from './dropDownFilterSubEntitie.pipe';



@NgModule({
  declarations: [FilterEntitiesPipe, FilterSubEntitiesPipe],
  imports: [
    CommonModule
  ],
  exports: [FilterEntitiesPipe, FilterSubEntitiesPipe
  ]
})
export class SearchPipesModuleModule { }
